import { create } from "zustand";
import { persist } from "zustand/middleware";
import { queryClient } from "@/queryClient";

interface AuthState {
  token?: string;
  setToken: (token: string) => void;
  clearToken: () => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      token: undefined,
      setToken: (token) => set({ token }),
      clearToken: () => {
        set({ token: undefined });
        queryClient.clear();
      },
    }),
    {
      name: "auth",
    },
  ),
);
